import type { MiningLogSummary } from '../hooks/useMiningLog';

interface MiningLogTableProps {
  entries: MiningLogSummary[];
}

export function MiningLogTable({ entries }: MiningLogTableProps) {
  if (entries.length === 0) {
    return <p className="text-muted-foreground text-sm">No mining activity yet.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b">
            <th className="text-left py-2 px-3 font-medium">Date</th>
            <th className="text-left py-2 px-3 font-medium">Land Type</th>
            <th className="text-right py-2 px-3 font-medium">Blocks Mined</th>
            <th className="text-left py-2 px-3 font-medium">Items</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.logId} className="border-b">
              <td className="py-2 px-3 text-muted-foreground">
                {new Date(entry.createdAt).toLocaleString()}
              </td>
              <td className="py-2 px-3">{entry.landType}</td>
              <td className="py-2 px-3 text-right">{entry.blocksMined}</td>
              <td className="py-2 px-3">
                {entry.itemsMinted.length > 0
                  ? entry.itemsMinted.map((item) => `${item.itemName} x${item.quantity}`).join(', ')
                  : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
